module.exports = __webpack_public_path__ + "static/img/待审核.455d382e.png";